import { z } from 'zod';
import { discountTypeSchema } from '../const/discountTypeSchema';
import { shippingTariffSchema } from '../const/shippingTariffSchema';

const roundTo90 = (value: number): number => {
    const safeValue = Math.max(value, 90);
    return Math.floor((safeValue - 90) / 100) * 100 + 90;
};

const itemSchema = z.object({
    productId: z.string().uuid(),
    sizeId: z.string().uuid(),
    count: z.number().min(1),
    price: z.object({
        price: z.number(),
        discount: z
            .object({
                type: z.enum(['none', 'real', 'fake']),
                percent: z.number().optional(),
            })
            .optional(),
    }),
    shoes: z.boolean(),
});

export const createPaymentSchema = z
    .object({
        tinkoffOrderId: z.string().uuid(),

        shippingTariff: shippingTariffSchema,
        city: z.string().min(1, 'Это поле обязательно для заполнения'),
        address: z.string().min(3, 'Это поле обязательно для заполнения'),

        fullName: z.string().min(3, 'Это поле обязательно для заполнения'),
        email: z.string().min(3, { message: 'Это поле обязательно для заполнения' }).email('Неверный формат почты'),
        phone: z.union([
            z.string().regex(/^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/, {
                message: 'Неверный формат телефона',
            }),
            z.literal(''),
        ]),

        discountId: z.string().uuid().optional(),
        discountType: discountTypeSchema.optional(),
        discountAmount: z.number().nonnegative().optional(),

        items: z.array(itemSchema).min(1, 'Должен быть хотя бы один товар'),
    })
    .refine(data => {
        const total = data.items.reduce<number>((acc, item) => {
            const { price, discount } = item.price;
            let final: number;

            if (!discount || discount.type === 'none' || typeof discount.percent !== 'number') {
                final = roundTo90(price);
            } else if (discount.type === 'real') {
                const pct = discount.percent;
                const raw = price * (1 - pct / 100);
                final = roundTo90(raw);
            } else {
                final = roundTo90(price);
            }

            return acc + final * item.count;
        }, 0);

        return total >= 100;
    });

export type CreatePaymentSchema = z.infer<typeof createPaymentSchema>;
